import { gsap, ScrollTrigger } from "gsap/all";

export function filter() {
  gsap.registerPlugin(ScrollTrigger);

  const wrappers = document.querySelectorAll(".filters-wrapper");

  wrappers.forEach((wrapper) => {
    const nav = wrapper.querySelector(".filters");
    const filters = nav.querySelectorAll("[data-filter]");
    const allElements = wrapper.querySelectorAll("[data-element]");
    const allContinentBlocks = document.querySelectorAll(
      ".heading-text-grid-block[data-continent]"
    );
    const animationDuration = 0.4;
    const ease = "power2.out";
    
    filters.forEach((filter) => {
        const trigger = filter.dataset.filter;
        if (trigger !== undefined) {
            const elements = wrapper.querySelectorAll(`[data-element="${trigger}"]`);
            if (elements && elements.length || trigger === 'all') {
                filter.addEventListener('click', () => {
                    // Remove active class from all filters
                    filters.forEach(f => f.classList.remove('active'));
                    
                    // Add active class to current filter
                    filter.classList.add('active');

                    // Scroll page to position nav at top of viewport
                    const wrapperRect = wrapper.getBoundingClientRect();
                    const currentScrollY = window.scrollY || window.pageYOffset;
                    const targetScrollY = currentScrollY + wrapperRect.top;
                    
                    gsap.to(document.documentElement, {
                        scrollTop: targetScrollY,
                        duration: animationDuration * 2,
                        ease: ease,
                    });

                    // Scroll nav if filter is not fully visible
                    const navRect = nav.getBoundingClientRect();
                    const filterRect = filter.getBoundingClientRect();
                    if (filterRect.left < navRect.left || filterRect.right > navRect.right) {
                        const navCenter = navRect.width / 2;
                        const filterCenter = filterRect.width / 2;
                        const scrollDistance = filterRect.left - navRect.left - navCenter + filterCenter;
                        
                        gsap.to(nav, {
                            scrollLeft: nav.scrollLeft + scrollDistance,
                            duration: animationDuration * 2,
                            ease: ease,
                        });
                    }

                    // Scroll content in percent
                    const scrollToMarkers = () => {
                        const sliderWrapper = wrapper.querySelector('.slider-wrapper');
                        if (!sliderWrapper) return;
                        
                        const scrollTo = filter.dataset.scrollTo || 0;
                        const scrollPercentage = parseFloat(scrollTo);
                        const maxScroll = sliderWrapper.scrollWidth - sliderWrapper.clientWidth;
                        const targetScroll = (maxScroll * scrollPercentage) / 100;
                        
                        gsap.to(sliderWrapper, {
                            scrollLeft: targetScroll,
                            duration: animationDuration * 2,
                            ease: ease,
                        });
                    };

                    // Filter elements with GSAP animation
                    if (trigger === 'all') {
                        // Show all elements
                        gsap.to(allElements, {
                            opacity: 1,
                            display: "block",
                            duration: animationDuration,
                            ease: ease,
                            onStart: scrollToMarkers(),
                        });
                        // Show all continent blocks
                        if (allContinentBlocks.length) {
                          gsap.to(allContinentBlocks, {
                            opacity: 1,
                            display: "block",
                            duration: animationDuration,
                            ease: ease,
                          });
                        }
                    } else {
                        // Hide all elements first
                        gsap.to(allElements, {
                            opacity: 0,
                            display: "none",
                            duration: animationDuration,
                            ease: ease,
                        });
                        // Hide all continent blocks
                        if (allContinentBlocks.length) {
                          gsap.to(allContinentBlocks, {
                            opacity: 0,
                            display: "none",
                            duration: animationDuration,
                            ease: ease,
                          });
                        }
                        
                        // Show only matching elements
                        gsap.to(elements, {
                            opacity: 1,
                            display: "block",
                            duration: animationDuration,
                            ease: ease,
                            onStart: scrollToMarkers(),
                        });
                        // Show only matching continent blocks
                        if (allContinentBlocks.length) {
                          const matchingBlocks = document.querySelectorAll(
                            `.heading-text-grid-block[data-continent="${trigger}"]`
                          );
                          gsap.to(matchingBlocks, {
                            opacity: 1,
                            display: "block",
                            duration: animationDuration,
                            ease: ease,
                          });
                        }
                    }
                });
            }
        }
    });
  });
}